import React, { useState, useEffect, Fragment, useRef, useCallback } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom'
import { MoonLoader } from 'react-spinners';
import { useDebounce } from '../../../hooks/useDebounce';
import {
  ViewSwitch,
  ButtonBasic,
  DropDownSelector,
  InputDynamicWidth,
  Checkbox,
  TableBox,
  Tooltip,
  Tabs,
  NotActive
} from '@lk-gtcom/ecomlab-components';
import { ModalAddTask } from '../../ComponentsCommonTasksLogic/ModalAddTask/ModalAddTask';
import { ModalNewTaskList } from '../../../components/Modal/ModalNewTaskList/ModalNewTaskList';
import { ModalAddExecutor } from '../../ComponentsCommonTasksLogic/Modal/ModalAddExecutor/ModalAddExecutor';
import { ModalListExecutor } from '../../ComponentsCommonTasksLogic/Modal/ModalListExecutor/ModalListExecutor';
import { ModalTaskStatus } from '../../../components/Modal/ModalTaskStatus/ModalTaskStatus';
import { ExecutorPlaceholder } from '../../../components/OptionsExecutor/OptionsExecutor';
import { ButtonWithIcon } from '../../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import { BordTask } from '../../ComponentsCommonTasksLogic/BoardLogic/BordTask/BordTask';
import { ColumnTask } from '../../ComponentsCommonTasksLogic/ColumnTask/ColumnTask';
import { ButtonsSort } from '../../../components/Buttons/BurronsSort/ButtonsSort';
import { StepItem } from '../../../components/StepItem/StepItem';
import { TaskListTable } from './TaskListTable/TaskListTable';
import { MainDirectory } from '../../MainDirectory/MainDirectory';
import { Main } from '../../Main/Main';
import { useDataTable } from '../../../common/hooks';
import { usePushNotifications } from '../../../common/pushNotification';
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from '../../../store/general';
import { RavshanHttp, RavshanHttps } from '../../../fetchUrls';
import { fromSnakeCase } from '../../../common/mappers';
import {
  addFiltersByDataObj,
  addFiltersToUrlQuery,
  getFiltersByUrlQuery,
  getDataObjByFilters,
} from '../../../common/utils';
import { Loader } from '../../../common/components/Loader/Loader';
import { useResponseHandler } from '../../../common/auth';
import { ModalSummaryCrm } from '../../ComponentsCommonTasksLogic/ModalSummaryCrm/ModalSummaryCrm';
import ModalWarning from '../../../components/Modal/ModalWarning/ModalWarning';
import './CRMList.scss';

// Иконки
import close_icon from './img/close_icon(members).svg';
import add_user from './img/account.svg';

// ==================== КОНСТАНТЫ ====================
export const TASK_EVENT_TYPE = 'Задача';

const task_permissible = [
  'В РАБОТЕ',
  'ГОТОВО',
  'НА ПРОВЕРКЕ',
  'НА СТОПЕ',
  'НОВЫЕ ЗАДАЧИ',
];

const btn_sort = [
  { label: 'A-Z', value: 'deal_name' },
  { label: 'По дате создания', value: 'deal_created_at' },
  { label: 'По сумме сделки', value: 'deal_sum' },
];

const FETCH_DELAY_MS = 1000;
const parse = require('html-react-parser');


const CRMListInner = ({ setSelectedProjectAbove }) => {
  // ==================== REFS ====================
  const refHeader = useRef();
  const refContainer = useRef();
  const refScrollbar = useRef();
  const refTaskBox = useRef();
  const refBoard = useRef();
  const refTable = useRef();
  const refsTotal = useRef([]);
  const paginatorRef = useRef();
  const containerRef = useRef();
  const tableContainerRef = useRef();

  // ==================== НАВИГАЦИЯ И ПАРАМЕТРЫ ====================
  const navigate = useNavigate();
  const path = useParams()['*'];
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = useParams()['*'];

  // ==================== STORE И ЗАГОЛОВКИ ====================
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();

  // ==================== ПОЛЬЗОВАТЕЛЬСКИЕ ДАННЫЕ ====================
  const client_id = localStorage.getItem('client_id');
  const email = localStorage.getItem('email');
  const eventId = sessionStorage.getItem('crmId');

  // ==================== МОДАЛЬНЫЕ ОКНА ====================
  const [isModal, setIsModal] = useState(false);
  const [isChatModal, setIsChatModal] = useState(false);
  const [showModalNewTaskList, setShowModalNewTaskList] = useState(false);
  const [showModalAddMember, setShowModalAddMember] = useState(false);
  const [isModalDeleteCol, setIsModalDeleteCol] = useState(false);
  const [isModalListExecutor, setIsModalListExecutor] = useState(false);
  const [isModalStatus, setIsModalStatus] = useState(false);
  const [isModalExit, setIsModalExit] = useState(false);
  const [isModalExportReport, setIsModalExportReport] = useState(false);

  // ==================== ДАННЫЕ ПРОЕКТА ====================
  const [tokenWiki, setTokenWiki] = useState(null);
  const [wikiId, setWikiId] = useState(null);
  const [fileId, setFileId] = useState(null);
  const [taskId, setTaskId] = useState(null);
  const [projectName, setProjectName] = useState(sessionStorage.getItem('crmProjectName'));
  const [infoTask, setInfoTask] = useState(false);
  const [removableTaskList, setRemovableTaskList] = useState('');
  const [selectedColumn, setSelectedColumn] = useState();

  // ==================== ФИЛЬТРЫ И ПОИСК ====================
  const [selectedExecutor, setSelectedExecutor] = useState([]);
  const [selectedCoExecutor, setSelectedCoExecutor] = useState([]);
  const [selectedAuthor, setSelectedAuthor] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [currentSort, setCurrentSort] = useState(null);
  const [sort1, setSort1] = useState(null);

  // ==================== ДАННЫЕ ЗАДАЧ И ПРОЕКТОВ ====================
  const [tasks, setTasks] = useState([]);
  const [prevTasks, setPrevTasks] = useState([]);
  const [columns, setColumns] = useState([]);
  const [author, setAuthor] = useState(null);
  const [projectAttendees, setProjectAttendees] = useState([]);
  const [projectPreview, setProjectPreview] = useState([]);
  const [selectedProjectPreview, setSelectedProjectPreview] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  const selectedProject = projectPreview.filter(({ value }) => value == taskId)?.[0]

  // ==================== СОСТОЯНИЯ ЗАГРУЗКИ ====================
  const [load, setLoad] = useState(false);
  const [loadTotal, setLoadTotal] = useState(true);
  const [loadTotalCount, setLoadTotalCount] = useState(false);
  const [isLoadInfoTask, setIsLoadInfoTask] = useState(false);
  const [columnsAreUpdating, setColumnsAreUpdating] = useState(true);
  const [columnNameIsUpdating, setColumnNameIsUpdating] = useState(false);
  const [iniitalQuery, setInitialQuery] = useState(true);

  // ==================== DRAG & DROP ====================
  const [actual, setActualElement] = useState(undefined);
  const [draggableColumn, setDraggableColumn] = useState('');
  const [columnDragStarted, setColumnDragStarted] = useState(false);
  const [isOver, setIsOver] = useState(false);

  // ==================== UI СОСТОЯНИЯ ====================
  const [selectView, setSelectView] = useState('Tile-long');
  const [isShowAllExecutor, setIsShowAllExecutor] = useState(false);
  const [isOpenActiveMenu, setIsOpenActiveMenu] = useState(false);
  const [isRead, setIsRead] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isShowAuthor, setIsShowAuthor] = useState(false);
  const [isEditCol, setIsEditCol] = useState(false);
  const [isBlockKey, setIsBlockKey] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [isShowAdditionalFields, setIsShowAdditionalFields] = useState(false);

  // ==================== ПОЗИЦИОНИРОВАНИЕ И СКРОЛЛ ====================
  const [positionElement, setPositionElement] = useState(0);
  const [bottom, setBottom] = useState(0);
  const [leftPosition, setLeftPosition] = useState(0);
  const [isFixed, setIsFixed] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [widthTaskList, setWidthTaskList] = useState(0);
  const [widtContainer, setWidtContainer] = useState(0);

  // ==================== ОБНОВЛЕНИЕ ДАННЫХ ====================
  const [isUpdateDataColumn, setIsUpdateColumn] = useState(false)
  const [updateCol, setUpdateCol] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [actualId, setActualId] = useState(-1);
  const [updateId, setUpdateId] = useState(-1);

  // ==================== ТАБЛИЦА ====================
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const [tableData, setTableData] = useState([]);
  const { setLoading } = setTableFuncs;
  const { filters, sort } = tableProps

  // ==================== СЧЕТЧИКИ ====================
  const [totalTaskGeneral, setTotalTaskGeneral] = useState(0);
  const [isUpdateTotal, setIsUpdateTotal] = useState(false);
  const [generalTotal, setGeneralTotal] = useState(0);
  const [countCol, setCountCol] = useState(0);
  const [totalProject, setTotalProject] = useState(0);

  // ==================== ДОСКИ ====================
  const [currentBord, setCurrentBord] = useState(null);
  const [bordListLength, setBordListLength] = useState(0);
  const [currentColumn, setCurrentColumn] = useState(null);

  // ==================== ПЕЧАТЬ ====================
  const [isVisibleCheckbox, setIsVisibleCheckbox] = useState(false);
  const [listPrint, setListPrint] = useState([]);

  // ==================== ДОСТУП ====================
  const [isAccess, setIsAccess] = useState(false);
  const [isAccessProject, setIsAccessProject] = useState(false);

  // ==================== НАВИГАЦИЯ ====================
  const [pageValue, setPageValue] = useState('');
  const [query, setQuery] = useState('');
  const [currPrjoect, setCurrPrjoect] = useState(taskId);
  const [pathsWebName, setPathsWebName] = useState('');
  const [paths, setPaths] = useState('');

  // ==================== ОБРАБОТКА ОШИБОК ====================
  const { addErrorPush, addSuccessPush } = usePushNotifications();

  // Конфигурация табов
  const btn_tab = [
    { label: 'Проект', value: `${taskId}` },
    { label: 'Wiki', value: `${taskId}/wiki` },
    { label: 'Чек-лист', value: `${taskId}/task_list` },
    { label: 'Файлы', value: `${taskId}/files` }
  ];

  // ==================== ФУНКЦИИ СКРОЛЛА ДЛЯ ТАБЛИЧНОГО ВИДА ====================
  const handleTableWheel = useCallback((e) => {
    // Для табличного вида обрабатываем вертикальный скролл тачпадом
    const tableContainer = tableContainerRef.current;
    if (!tableContainer || selectView !== 'Table') return;

    // Для вертикального скролла в таблице
    const isVerticalScroll = Math.abs(e.deltaY) > Math.abs(e.deltaX);

    if (isVerticalScroll) {
      // Позволяем вертикальному скроллу работать
      return;
    }

    // Для горизонтального скролла в таблице (если он есть)
    const isShiftPressed = e.shiftKey;
    const hasHorizontalScroll = Math.abs(e.deltaX) > Math.abs(e.deltaY);

    if ((isShiftPressed || hasHorizontalScroll) && tableContainer) {
      e.preventDefault();
      tableContainer.scrollLeft += e.deltaX || e.deltaY;
    }
  }, [selectView]);

  const syncScroll = useCallback(() => {
    if (refContainer.current && refScrollbar.current) {
      refScrollbar.current.scrollLeft = refContainer.current.scrollLeft;
    }
  }, []);

  const handleWheel = useCallback((e) => {
    // Если нажат Shift или это горизонтальный скролл (deltaX != 0)
    const isShiftPressed = e.shiftKey;
    const hasHorizontalScroll = Math.abs(e.deltaX) > Math.abs(e.deltaY);

    if ((isShiftPressed || hasHorizontalScroll) && refContainer.current) {
      e.preventDefault();

      const scrollDelta = e.deltaX !== 0 ? e.deltaX : e.deltaY;

      refContainer.current.scrollLeft += scrollDelta;

      // Синхронизируем скроллбар
      if (refScrollbar.current) {
        refScrollbar.current.scrollLeft = refContainer.current.scrollLeft;
      }
    }
  }, []);

  useEffect(() => {
    if (taskId) {
      if (activeTab?.includes('wiki')) {
        setPageValue(`${taskId}/wiki`)
      } else if (activeTab?.includes('task_list')) {
        setPageValue(`${taskId}/task_list`)
      } else if (activeTab?.includes('files')) {
        setPageValue(`${taskId}/files`)
      } else {
        setPageValue(`${taskId}`)
      }
    }
  }, [taskId]);

  // Получение токена для wiki
  const fetchProductIds = (id) => {
    const url = ` https://portals.ecomru.ru/api/v2/article/wiki_token?wiki_id=${id}`
    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then(json => {
        if (json) {
          setTokenWiki(json)
        }
      })
      .catch(err => console.error(err))
  }

  // Получение wiki-id по проекту
  const fetchGetWikiId = (project_id) => {
    if (!project_id) return
    let url = ` https://portals.ecomru.ru/api/crm/projects/wiki_id/${project_id}`

    fetch(url, { method: 'get', headers })
      .then(handleTableResponse)
      .then(json => {
        if (json) {
          fetchProductIds(json)
          setWikiId(json)
        }
      })
      .catch(err => console.error(err))
  }

  useEffect(() => {
    if (taskId != -1) {
      fetchGetWikiId(taskId)
    }
  }, [taskId]);

  useEffect(() => {
    if (countCol == columns.length) {
      setLoadTotal(false)
    }
  }, [countCol])


  const openTask = (e, eventId, project, taskId) => {
    sessionStorage.setItem('crmId', eventId);
    sessionStorage.setItem('crmProjectId', project ? project : taskId);
    setTaskId(project ? project : taskId);
    const urlParams = new URLSearchParams(window.location.search);
    if (!path.match(eventId)) {
      navigate(`/crm/crm-list/${taskId}/${eventId}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`);
    }
    const el = e?.target;
    if (el && el?.closest('.btn-and-options-box')) {
      return;
    } else {
      fetchInfoTask(eventId);
    }
  };

  const dragStartHandler = (e, card, id_col) => {
    setActualElement({ ...card, typeId: id_col });
  };

  const dragOverHandler = (e) => {
    e.preventDefault();
  };

  // Изменение статуса задачи(task_type)
  // done
  const fetchSetTaskType = (event_id, selected) => {
    let url = ` https://portals.ecomru.ru/api/crm/deals/step/{deal_id}`

    const body = JSON.stringify({
      deal_id: event_id,
      step_id: selected,
    });

    fetch(url, { body, method: 'PATCH', headers })
      .then(handleTableResponse)
      .then((json) => {
      })
      .catch((err) => console.error(err));
  }

  // получение total
  const fetchGetTotal = (filter) => {
    setLoadTotalCount(true)

    let url = ` https://portals.ecomru.ru/api/crm/projects/total_deals/${taskId}`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        setTotalProject(json)
        setLoadTotalCount(false)
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (taskId) {
      fetchGetTotal()
    }
  }, [
    selectedExecutor,
    selectedCoExecutor,
    selectedStatus,
    selectedStatus,
    taskId,
    searchValue,
    isRead,
    isDelete,
  ]);

  const dropCardHandler = (e, status) => {
    console.log(status)
    e.preventDefault();
    if (!actual) return;
    if (+taskId === -1) return;
    setPrevTasks(tasks);
    const tasksWithNewStatus = tasks.map((el) =>
      el?.id === actual?.id
        ? { ...actual, taskType: { id: status.id, name: status.name } }
        : el
    );
    setTasks(tasksWithNewStatus);
    fetchSetTaskType(actual?.id, status?.id);
    // fetchUpdateTask(actual, status)
    setActualElement(false);
  };

  const dragStartColumn = (e, column) => {
    if (!e.target.getAttribute('column')) return;
    setDraggableColumn(column);
    setColumnDragStarted(true);
  };

  const dropColumnHandler = (e, col) => {
    e.preventDefault();
    e.target.classList.remove('hover');

    if (!draggableColumn) return;
    const currentPlace = col?.id;
    updateTaskListPlace(draggableColumn?.id, draggableColumn?.name, currentPlace)
    setDraggableColumn(null);
    setColumnDragStarted(false);
  };

  const customDragScrollHandler = (event) => {
    const container = containerRef.current;
    const scrollZoneWidth = 100;

    const cursorX = event.clientX - container?.getBoundingClientRect().left;

    if (cursorX < scrollZoneWidth) {
      container.scrollLeft -= 2;
      if (refScrollbar.current) {
        refScrollbar.current.scrollLeft = container.scrollLeft;
      }
    } else if (cursorX > container?.offsetWidth - scrollZoneWidth) {
      container.scrollLeft += 2;
      if (refScrollbar.current) {
        refScrollbar.current.scrollLeft = container.scrollLeft;
      }
    }
  };

  const handleSearch = (value) => {
    setColumnsAreUpdating(true);
    setSearchValue(value);
  };

  const checkAttendee = (id) => {
    const executor = selectedExecutor?.indexOf(id) > -1;
    const coexecutor = selectedCoExecutor?.indexOf(id) > -1;
    const author = selectedAuthor?.indexOf(id) > -1;

    return +executor + coexecutor + author;
  };

  const arr_projectAttendees = projectAttendees?.map(
    ({ id, name, login, color }, ind) => {
      return (
        <div
          className="selected-members"
          key={id}
          style={{
            cursor: 'pointer',
            border:
              selectedExecutor?.indexOf(id) !== -1
                ? '1px solid #51CA64'
                : '1px solid white',
            borderRadius: '50%',
            marginLeft: ind != 0 ? '-8px' : '',
            position: 'relative',
            zIndex: selectedExecutor?.indexOf(id) !== -1 ? 2 : 1,
          }}
          onClick={(e) => {
            setSelectedExecutor((prev) => {
              if (prev?.indexOf(id) === -1) {
                return [...prev, id];
              } else {
                return prev?.filter((el) => el !== id);
              }
            });
            setColumnsAreUpdating(true);
            setUpdateCol(true);
          }}
        >
          <ExecutorPlaceholder
            bkg={
              selectedExecutor?.length > 0 &&
                selectedExecutor?.indexOf(id) === -1
                ? '#DDE0DD'
                : ''
            }
            name={name}
            color={color}
            email={login}
          />
        </div>
      );
    }
  );


  // Проверка доступа к проекту
  const fetchAccessProject = () => {
    if (taskId == -1) {
      setIsAccessProject(true)
    } else {
      let url = ` https://portals.ecomru.ru/api/crm/projects/check/availability?project_id=${taskId}`

      fetch(url, { headers })
        .then(handleTableResponse)
        .then((json) => {
          setIsAccessProject(json)
          if (json === false) {
            addErrorPush(`У вас нет доступа к проекту ID-${taskId}`)
            navigate('/crm/project-for-crm/project')
          }
        })
        .catch((err) => console.error(err))
        .finally(() => { });
    }
  };

  useEffect(() => {
    if (taskId) {
      fetchAccessProject()
    }
  }, [taskId]);

  // Проверка доступа к сделке
  const fetchAccess = (id) => {
    let url = ` https://portals.ecomru.ru/api/crm/deals/check_availability/deal?deal_id=${id}`
    setIsLoadInfoTask(true);

    fetch(url, { headers })
      .then(handleTableResponse)
      .then((json) => {
        setIsAccess(json)
        if (json === false) {
          addErrorPush(`У вас нет доступа к сделке ID-${id}`)
          navigate('/crm/project-for-crm/project')
        }
      })
      .catch((err) => console.error(err))
      .finally(() => { });
  };

  useEffect(() => {
    const paths = path?.split('/');
    const [project, task] = paths;
    if (task) {
      fetchAccess(task)
    }
  }, [path]);


  const fetchInfoTask = (id) => {
    let url = ` https://portals.ecomru.ru/api/crm/deals/${id}`
    setIsLoadInfoTask(true);

    const getHeaders = {
      ...headers,
      'event-id': +id,
      active: true,
    };

    fetch(url, { headers: getHeaders })
      .then(handleTableResponse)
      .then((json) => {
        setInfoTask(fromSnakeCase(json));
        setIsModal(true)
      })
      .catch((err) => console.error(err))
      .finally(() => setIsLoadInfoTask(false));
  };

  // Список статусов в по сотрудникам
  const fetchTaskTypes = (id) => {
    let url = ` https://portals.ecomru.ru/api/crm/projects/projects/steps`;

    fetch(url, { headers: headers })
      .then(handleTableResponse)
      .then((json) => {
        setStatusOptions(
          json?.map((el) => ({ label: el, value: el }))
        );
      })
      .catch((err) => console.error(err))
      .finally(() => setIsLoadInfoTask(false));
  };

  useEffect(() => {
    if (taskId == -1 && isAccessProject) {
      fetchTaskTypes()
    }
  }, [taskId, isAccessProject]);

  // Получение автора
  const fetchProjects = (taskId, abortController = new AbortController()) => {
    // if (!taskId) return;

    // setLoad(true);

    // let url;
    // if (!window.location.hostname.match('localhost')) {
    //   url = `${RavshanHttps}/api/v2/tasks/get_event_by_project_new`;
    // } else {
    //   url = `${RavshanHttp}/api/v2/tasks/get_event_by_project_new`;
    // }

    // const executor =
    //   selectedExecutor?.length > 0 ? { executor: selectedExecutor } : {};
    // const author = selectedAuthor?.length > 0 ? { author: selectedAuthor } : {};
    // const co_executor =
    //   selectedCoExecutor?.length > 0 ? { co_executor: selectedCoExecutor } : {};
    // const taskType =
    //   selectedStatus?.length > 0
    //     ? { task_type: selectedStatus?.map(({ value }) => value) }
    //     : {};

    // const body = JSON.stringify({
    //   project_id: +taskId,
    //   ...executor,
    //   ...co_executor,
    //   ...author,
    //   ...taskType,
    //   unviewed: isRead,
    //   order_field: currentSort?.value ? currentSort?.value : 'deal_created_at',
    //   order_direction: sort1 == 'ASC' ? 'desc' : 'asc',
    //   search: searchValue,
    //   on_trash: isDelete,
    // });

    // fetch(url, {
    //   body,
    //   method: 'POST',
    //   headers,
    //   signal: abortController.signal,
    // })
    //   .then((res) => {
    //     if (res.ok) {
    //       return res.json();
    //     } else {
    //       throw new Error('bad events response');
    //     }
    //   })
    //   .then((json) => {
    //     const { project_name, author, attendee, task_type_list } = json;
    //     setProjectName(project_name ? project_name : 'По сотрудникам');
    //     setAuthor(author);
    //     // setStatusOptions(
    //     //   task_type_list?.map((el) => ({ label: el, value: el }))
    //     // );
    //     setProjectAttendees(
    //       attendee.sort((a, b) => checkAttendee(b.id) - checkAttendee(a.id))
    //     );
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   })
    //   .finally(() => {
    //     setLoad(false);
    //   });
  };

  useEffect(() => {
    if (!showModalAddMember && isAccessProject) {
      fetchGetAttendees();
    }
  }, [taskId, showModalAddMember, isAccessProject]);

  const fetchProjectsAttendee = (taskId) => {
    if (!taskId) return;

    let url = `${RavshanHttps}/api/tasks/project_client_team`;

    const getHeaders = {
      ...headers,
      'project-id': +taskId,
    };

    fetch(url, { headers: getHeaders })
      .then(handleTableResponse)
      .then((json) => {
        setProjectAttendees(
          json.sort((a, b) => checkAttendee(b.id) - checkAttendee(a.id))
        );
      })
      .catch((err) => console.error(err));
  };

  // Получение колонок по доске
  const fetchAllColumns = (
    delayMs,
    taskId,
    abortController = new AbortController()
  ) => {
    if (!taskId) return;
    setColumnsAreUpdating(true);
    setCountCol(0)
    setLoadTotal(true)
    const url = ` https://portals.ecomru.ru/api/crm/steps/${currentBord?.id}`;
    const urlsByEmployee = ` https://portals.ecomru.ru/api/crm/projects/projects`

    const taskTypeValue = selectedStatus?.map(({ value }) => value);
    const taskType = taskTypeValue ? { step_id_list: taskTypeValue } : {};

    const body = JSON.stringify({
      responsible_list: selectedExecutor?.length > 0 ? selectedExecutor : [],
      author_list: selectedAuthor?.length > 0 ? selectedAuthor : [],
      co_executors_list: selectedCoExecutor?.length > 0 ? selectedCoExecutor : [],
      ...taskType,
    })

    const fetchCallback = () =>
      fetch(taskId == -1 ? urlsByEmployee : url, {
        method: 'POST',
        headers,
        signal: abortController.signal,
        body
      })
        .then(handleTableResponse)
        .then((json) => {
          if (!Array.isArray(json)) return;
          setColumns(
            json.sort((a, b) => a.place - b.place).map((c) => fromSnakeCase(c))
          );
          setGeneralTotal(0)
        })
        .finally(() => {
          if (abortController.signal.aborted) return;
          setColumnsAreUpdating(false);
        });

    if (delayMs) setTimeout(fetchCallback, delayMs);
    else fetchCallback();
  };

  // Получение колонок по сотрудникам
  const fetchAllColumnsByEmployee = (
    delayMs,
    taskId,
    abortController = new AbortController()
  ) => {
    if (!taskId) return;
    setColumnsAreUpdating(true);
    setCountCol(0)
    setLoadTotal(true)
    const url = ` https://portals.ecomru.ru/api/crm/projects/projects`

    const body = JSON.stringify({
      responsible_list: [],
      author_list: [],
      co_executors_list: []
    })

    const fetchCallback = () =>
      fetch(url, { method: 'POST', headers, signal: abortController.signal, body })
        .then(handleTableResponse)
        .then((json) => {
          if (!Array.isArray(json)) return;
          setColumns(
            json.sort((a, b) => a.place - b.place).map((c) => fromSnakeCase(c))
          );
          setGeneralTotal(0)
        })
        .finally(() => {
          if (abortController.signal.aborted) return;
          setColumnsAreUpdating(false);
        });

    if (delayMs) setTimeout(fetchCallback, delayMs);
    else fetchCallback();
  };

  // Удалить сделку

  const fetchDeleteTask = (id, on_trash) => {
    let url = `${RavshanHttp}/api/crm/deals/${id}`

    fetch(url, { method: 'DELETE', headers })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          const errorMessage = data.detail || res.statusText;
          addErrorPush(`Ошибка: ${errorMessage}`);
          throw new Error(`${res.status} ${errorMessage}`);
        } else {
          addSuccessPush(`Сделка ID-${id} удалена`)
        }
        return data;
      })
      .then(() => { })
      .catch(err => console.error(err))
      .finally(() => {
        setIsModal(false)
      })
  }

  // Добавление колонки
  const addNewTaskList = (name, before = columns?.at(-1)?.id || null) => {
    const url = ` https://portals.ecomru.ru/api/crm/steps/`;
    const body = JSON.stringify({
      name,
      before,
      funnel_id: currentBord?.id
    });
    fetch(url, { body, method: 'POST', headers })
      .then(res => {
        if (res.status === 409) {
          addErrorPush('Лимиты по тарифу исчерпаны')
          navigate('/crm/project-for-crm/project')
        }
        if (!res?.ok) {
          throw new Error('bad response')
        }
        if (res?.ok) {
          fetchAllColumns(500, +taskId);
        }
        return res.json()
      })
  };

  // Ихменение колонок
  const updateTaskListPlace = (id, name, before) => {
    if (id == before) return
    const url = ` https://portals.ecomru.ru/api/crm/steps/`;
    const body = JSON.stringify({
      step_id: id,
      name,
      before,
      funnel_id: currentBord?.id
    });

    fetch(url, { body, method: 'PUT', headers }).then((response) => {
      if (response.ok) {
        fetchAllColumns(500, +taskId);
        fetchProjects(+taskId);
        setUpdateCol(true);
      } else {
        throw new Error('bad update task list place response');
      }
    });
  };

  // Получение проектов по пространству
  const fetchProjectPreview = (taskId, abortController = new AbortController()) => {
    let url = ` https://portals.ecomru.ru/api/crm/projects/?page=1&limit=10000`

    fetch(url, { headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        const { data, total } = json
        setProjectPreview(
          [...data]?.map(
            ({ id, name }) => ({ label: name, value: id })
          )
        );
        if (!projectName & taskId) {
          const projectName = json.filter(({ id }) => id === +taskId)[0]?.name;
          sessionStorage.setItem(
            'crmProjectName',
            projectName
              ? projectName
              : taskId === -1
                ? 'По сотрудникам'
                : 'Не найдено'
          );
        }
      })
      .catch((err) => console.error(err));
  };

  // Список участников для проекта
  const fetchGetAttendees = (abortController = new AbortController()) => {
    if (!taskId) return;

    let url = ` https://portals.ecomru.ru/api/crm/projects/attendees/${taskId}`

    fetch(url, { method: 'GET', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        const { attendees, author } = json
        // const { project_name, author, events, attendee, task_type_list } = json
        // setProjectName(project_name ? project_name : 'По сотрудникам')
        setAuthor(author)
        // setTasks(events?.map(e => fromSnakeCase(e)).filter(e => e.eventType === TASK_EVENT_TYPE))
        // json?.forEach((el) => {
        //   const { login, color, name } = el;
        //   if (login === email) {
        //     // localStorage.setItem('currentUserColor', color);
        //     // localStorage.setItem('currentUserName', name);
        //   }
        // });
        // setStatusOptions(task_type_list?.map(el => ({ label: el, value: el }))
        const curr = attendees.map((el) => ({ ...el, executor: el.responsible }))
        setProjectAttendees(
          curr.sort((a, b) => checkAttendee(b.id) - checkAttendee(a.id))
        );
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const openModal = (column) => {
    setIsNew(true);
    setSelectedColumn(column);
    setIsModal(true);
  };

  ////////////////////////////////////////////////////// 
  // Добавить участника в проект
  const addNewMember = (attendee_id) => {
    const project_id = +taskId;
    const url = ` https://portals.ecomru.ru/api/crm/projects/attendee/add`;

    const body = JSON.stringify({
      attendee_id,
      project_id,
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {
      })
      .catch((err) => console.error(err));
  };

  // Удалить участников из проекта
  const deleteMember = (attendee_id) => {
    const project_id = +taskId;
    let url = ` https://portals.ecomru.ru/api/crm/projects/attendee/remove`

    const body = JSON.stringify({
      attendee_id,
      project_id,
    });

    fetch(url, { method: 'DELETE', headers, body })
      .then(handleTableResponse)
      .then(json => {
      })
      .catch((err) => console.error(err));
  };

  const fetchProjectToRedirect = (projectId) => {
    const url = `${RavshanHttps}/api/tasks/get_project`;

    const body = JSON.stringify({
      executor: selectedExecutor,
      search: '',
    });

    fetch(url, { body, headers })
      .then(handleTableResponse)
      .then((projects) => {
        const project = projects?.filter((el) => el?.task_id === +projectId)[0];
        if (project) {
          const { name, task_id } = project;
          sessionStorage.setItem(
            'crmProjectName',
            name ? name : taskId === -1 ? 'По сотрудникам' : 'Не найдено'
          );
          navigate(`/crm/crm-list/${task_id}`);
        }
      })
      .catch((err) => console.error(err));
  };

  // Удаление колонки
  const deleteTaskList = () => {
    const url = ` https://portals.ecomru.ru/api/crm/steps/?step_id=${removableTaskList.id}`;
    const body = JSON.stringify({
      step_id: removableTaskList.typeId,
    });
    fetch(url, { body, method: 'DELETE', headers }).then((response) => {
      if (response.ok) {
        fetchAllColumns(false, +taskId);
        fetchProjectPreview();
        fetchProjects(+taskId);
      } else {
        throw new Error('bad delete task list response');
      }
    });
  };

  // Табличный вид
  const fetchTableData = (params, abortController = new AbortController()) => {
    let _sort;
    let filtersParam;

    if (params) {
      [_sort, filtersParam] = params;
    }
    setLoading(true);
    setTableData([]);

    let url_by_employee = 'https://portals.ecomru.ru/api/crm/deals/attendee_project/table_view'
    let url = `https://portals.ecomru.ru/api/crm/deals/funnel/${currentBord?.id}`

    const body = JSON.stringify({
      limit: paginatorRef?.current?.limit || 10,
      page: paginatorRef?.current?.page || 1,
      search: searchValue,
      order_field: _sort?.[0] || sort?.[0],
      responsible_list: selectedExecutor?.length > 0 ? selectedExecutor : [],
      author_list: selectedAuthor?.length > 0 ? selectedAuthor : [],
      co_executors_list: selectedCoExecutor?.length > 0 ? selectedCoExecutor : [],
      order_direction: _sort?.[1] || sort?.[1],
      filters: Array.isArray(filtersParam) ? filtersParam : filters,
      show_additional_fields: isShowAdditionalFields
    });

    fetch(
      taskId == -1 ? url_by_employee : url,
      {
        method: 'POST',
        headers,
        body,
        signal: abortController.signal
      })
      .then(handleTableResponse)
      .then((json) => {
        json?.data?.map((el) => {
          if (el[2]) {
            const parsed = parse(el[2]);
            el[2] = React.createElement('div', null, parsed);
          }
          if (!el[1]) {
            el[1] = 'Нет названия';
          }
          return el;
        });
        setTable(json);
      })
      .catch((e) => console.error(e))
      .finally(() => {
        if (abortController.signal.aborted) return
        setLoading(false)
      })
  };

  // Таблица
  useEffect(() => {
    if (selectView == 'Table' && !isModal) {
      const abortController = new AbortController()
      setTimeout(() => fetchTableData([], abortController), 500)
      return () => abortController.abort()
    }
  }, [
    selectView,
    searchValue,
    selectedExecutor,
    selectedAuthor,
    selectedCoExecutor,
    currentBord?.id,
    isModalDeleteCol,
    isModal,
    isShowAdditionalFields
  ]);

  useEffect(() => {
    const paths = path?.split('/');
    if (paths) {
      const [project, task] = paths;
      if (project) {
        sessionStorage.setItem('crmProjectId', project);
        setTaskId(project);
        setCurrPrjoect(project);
      }
      if (!projectName) {
        fetchProjectPreview(+project);
      }
      if (task) {
        sessionStorage.setItem('crmId', task);
        if (!(activeTab.includes('wiki') ||
          activeTab.includes(`task_list`) ||
          activeTab.includes(`files`))) {
          if (isAccess) {
            openTask(null, task, +project, taskId);
          }
        }
        if (project) {
          fetchProjects(+project);
          fetchAllColumns(false, +project);
        }
      }
      return;
    }
    if (!taskId) {
      navigate('/crm/project-for-crm/project');
      return;
    } else {
      if (eventId) {
        navigate(`/crm/crm-list/${taskId}/${eventId}`);
      }
    }
  }, [isAccess]);

  useEffect(() => {
    if (taskId && isAccessProject) {
      const abortController = new AbortController();
      fetchProjects(taskId, abortController);
    }
  }, [taskId, isAccessProject]);

  useEffect(() => {
    const abortController = new AbortController();
    if (!isModal || columns?.length < 1) {
      //   setLoad(true)
      setTimeout(() => {
        fetchAllColumns(false, taskId, abortController);
        fetchProjectPreview(taskId, abortController);
      }, FETCH_DELAY_MS);

      if (updateCol) {
        setUpdateCol(false)
      }
    }
    return () => abortController.abort()
  }, [
    selectedSpace,
    showModalAddMember,
    searchValue,
    updateCol,
    taskId,
    sort1,
    currentSort,
    isRead,
    isDelete,
    searchValue,
    currentBord
  ])

  useEffect(() => {
    if (!isModal) {

    }
  }, [isModal]);

  useEffect(() => {
    if (iniitalQuery) {
      const dataObj = getFiltersByUrlQuery(searchParams);
      addFiltersByDataObj({
        dataObj,
        setSelectedAuthor,
        setSelectedExecutor,
        setSelectedCoExecutor,
        setCurrentSort,
        setSelectedStatus,
        setSearchValue,
        setSort1,
        setCurrentBord
      });
      setInitialQuery(false);
    }
  }, [searchParams]);

  //Запись
  useEffect(() => {
    if (iniitalQuery) return;
    const dataObj = getDataObjByFilters({
      selectedAuthor,
      selectedCoExecutor,
      selectedExecutor,
      selectedStatus,
      currentSort,
      searchValue,
      sort1,
      currentBord
    });
    addFiltersToUrlQuery(dataObj, setSearchParams);
  }, [
    selectedAuthor,
    selectedCoExecutor,
    selectedExecutor,
    selectedStatus,
    currentSort,
    searchValue,
    sort1,
    currentBord
  ]);



  useEffect(() => {
    const id = selectedProjectPreview?.value?.id;
    if (id) {
      fetchProjectToRedirect(id);
    }
  }, [selectedProjectPreview, selectedSpace]);

  const handleScroll = () => {
    const container = refContainer.current;
    const headerr = refHeader.current;
    const header = document.querySelector('.col-task__white');
    const top = container.getBoundingClientRect().top;
    const bottom = container.getBoundingClientRect().top;

    let height;
    if (header) {
      height = header.getBoundingClientRect().height;
    }

    if (top < 0) {
      setPositionElement(-top);
    } else {
      setPositionElement(0);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const observer = new ResizeObserver((entries) => {
    const { width } = entries[0].contentRect;
    setWidthTaskList(width);
  });

  useEffect(() => {
    if (refContainer?.current) {
      observer.observe(refContainer?.current);
    }
  }, [refContainer, observer]);

  // Синхронизируем скролл
  const positionScroll = () => {
    if (refContainer?.current && refScrollbar?.current) {
      refContainer.current.scrollLeft = refScrollbar.current.scrollLeft;
    }
  };

  const scrollBottom = () => {
    positionScroll();
    const left = refContainer?.current?.getBoundingClientRect().left;
    // const width = refContainer?.current?.scrollWidth;
    const width = (columns?.length * 240)
    const scrollWidth = refTaskBox?.current?.scrollWidth;

    // Ширина таблицы
    const widthTaskList = refContainer?.current?.getBoundingClientRect().width;
    setWidthTaskList(widthTaskList);
    setLeftPosition(left); //left
    // setWidtContainer(width); //right
    //  setScrollWidth(scrollWidth) //width

    // Видимость скроллбара
    const heightDocument = document.documentElement.clientHeight;
    setBottom(refContainer?.current?.getBoundingClientRect().bottom);
    if (heightDocument) {
      const pointBottom =
        refContainer?.current?.getBoundingClientRect().bottom >
        document.documentElement.clientHeight;
      const pointTop = refContainer?.top > 0;
      setIsFixed(pointBottom || pointTop ? true : false);
    }

    //верхняя точка скроллбара
    if (heightDocument) {
      const pointTop =
        refContainer?.current?.getBoundingClientRect().top >
        document.documentElement.clientHeight;
      setIsVisible(pointTop ? false : true);
    }
  };

  // // скролл таблицы shift + wheel
  const scrollWheel = (e) => {
    const isShift = e?.shiftKey;
    if (refContainer?.current && refScrollbar?.current && isShift) {
      refScrollbar.current.scrollLeft = refContainer.current.scrollLeft;
    }
  };

  // // Скролл кнопками
  const scrollKey = (e) => {
    const el = e.target
    console.log()
    if (el.closest('.blackout')) {
      return
    }

    if (!isModal & !isBlockKey) {
      const left = 37;
      const right = 39;

      if (e?.keyCode === left || e?.keyCode === right) {
        refContainer?.current?.focus();
      }
    }

    if (refContainer?.current && refScrollbar?.current && !isBlockKey) {
      refScrollbar.current.scrollLeft = refContainer.current.scrollLeft;
    }
  };

  useEffect(() => {
    const widthTaskList = (columns?.length * 256) + (isOpen ? 210 : 48);
    setWidtContainer(widthTaskList);
  }, [columns, isOpen]);

  useEffect(() => {
    window.addEventListener('scroll', scrollBottom);
    window.addEventListener('resize', scrollBottom);
    refContainer?.current?.addEventListener('wheel', scrollWheel);

    return () => {
      window.removeEventListener('scroll', scrollBottom);
      window.removeEventListener('resize', scrollBottom);
      refContainer?.current?.removeEventListener('wheel', scrollWheel);
    };
  }, [isModal]);

  // Настройка обработчиков скролла для табличного вида
  useEffect(() => {
    if (selectView === 'Table' && tableContainerRef.current) {
      const tableContainer = tableContainerRef.current;

      const tableWheelHandler = (e) => {
        handleTableWheel(e);
      };

      tableContainer.addEventListener('wheel', tableWheelHandler, { passive: false });

      return () => {
        tableContainer.removeEventListener('wheel', tableWheelHandler);
      };
    }
  }, [selectView, handleTableWheel]);

  // Настройка обработчиков скролла для обычного вида
  useEffect(() => {
    const container = refContainer.current;
    const scrollbar = refScrollbar.current;

    if (!container || selectView === 'Table') return;

    // Обработчик wheel для тачпада
    const wheelHandler = (e) => {
      handleWheel(e);
    };

    // Обработчик скролла для синхронизации
    const scrollHandler = () => {
      syncScroll();
    };

    // Добавляем слушатели
    container.addEventListener('wheel', wheelHandler, { passive: false });
    container.addEventListener('scroll', scrollHandler);

    if (scrollbar) {
      scrollbar.addEventListener('scroll', () => {
        if (container) {
          container.scrollLeft = scrollbar.scrollLeft;
        }
      });
    }

    return () => {
      // Убираем слушатели при размонтировании
      container.removeEventListener('wheel', wheelHandler);
      container.removeEventListener('scroll', scrollHandler);

      if (scrollbar) {
        scrollbar.removeEventListener('scroll', () => { });
      }
    };
  }, [handleWheel, syncScroll, selectView]);

  useEffect(() => {
    // refContainer?.current?.focus();
    window?.addEventListener('keydown', scrollKey);

    return () => {
      window?.removeEventListener('keydown', scrollKey);
    };
  }, [
    refContainer?.current,
    columns?.length,
    isModal,
    showModalAddMember,
    showModalNewTaskList,
    isModalListExecutor,
    isModalDeleteCol,
    isChatModal,
    isBlockKey
  ]);

  useEffect(() => {
    positionScroll();
    scrollBottom();
  }, [refTaskBox?.current]);

  useEffect(() => {
    positionScroll();
    scrollBottom();
  }, [tasks]);

  useEffect(() => {
    const params = new URL(document.location).searchParams;
    let query = params.get('filter');
    setQuery(query);
    if (query == 'my_project') {
      setSelectedAuthor([Number(client_id)]);
    }
  }, [new URL(document.location).searchParams]);


  // Смена проекта без перезагрузки страницы:
  // меняем URL через navigate, а обёртка CRMList перемонтирует компонент по key
  useEffect(() => {
    if ((currPrjoect != taskId) && taskId) {
      const urlParams = new URLSearchParams(window.location.search);
      navigate(
        `/crm/crm-list/${currPrjoect}${urlParams.toString() ? `?${urlParams.toString()}` : ''
        }`
      );
    }
  }, [currPrjoect]);

  // Получение id файловой системы
  const fetchGetFileId = () => {
    if (!taskId) return
    let url = ` https://portals.ecomru.ru/api/crm/projects/file_system_id/${taskId}`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        if (json) {
          setFileId(json)
        }
      })
      .catch((err) => console.error(err));
  }

  useEffect(() => {
    if (taskId) {
      fetchGetFileId()
    }
  }, [taskId]);

  // Получение id 
  const fetchGetId = (id) => {
    if (!id) return
    let url = ` https://portals.ecomru.ru/api/crm/projects/file_system_id/${id}`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        // setIdTable(json);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    const pathParts = window.location.pathname.split('/');
    // fetchGetId(pathParts.at(-2))
  }, []);

  const onActionTable = (e) => {
    const paths = path?.split('/');
    if (paths) {
      const [project, task] = paths;
      openTask(null, e?.[`id сделки`], +project, taskId);
    }
  }

  const deboudnceSearchTask = useDebounce(handleSearch, 1000)

  const contextMenuArr = [
    {
      label: 'Посмотреть',
      onClick: (e) => {
        const [project, task] = paths;
        openTask(null, e?.[`id сделки`], +project, taskId);
      },
    }
  ];

  return (
    <>
      {/* СПИСОК СОТРУДНИКОВ */}
      {showModalAddMember && <ModalAddExecutor
        crm
        projectAttendees={projectAttendees?.map(el => el?.id)}
        deleteMember={deleteMember}
        addNewMember={name => addNewMember(name)}
        close={() => setShowModalAddMember(false)}
        projectId={taskId} />}

      {showModalNewTaskList && <ModalNewTaskList add={name => addNewTaskList(name)} close={() => setShowModalNewTaskList(false)} />}

      {isModalListExecutor && <ModalListExecutor
        setColumnsAreUpdating={e => setColumnsAreUpdating(e)}
        executors={projectAttendees}
        setIsModal={(e) => setIsModalListExecutor(e)}
        selectedExecutor={selectedExecutor}
        selectedCoExecutor={selectedCoExecutor}
        selectedAuthor={selectedAuthor}
        setSelectedAuthor={(e) => setSelectedAuthor(e)}
        checkAttendee={checkAttendee}
        setSelectedExecutor={e => setSelectedExecutor(e)}
        setSelectedCoExecutor={e => setSelectedCoExecutor(e)}
        updateData={e => {
          fetchAllColumns(false, +taskId)
          fetchProjects(+taskId)
          fetchProjectPreview()
        }}
      />}

      {isModalDeleteCol &&
        <ModalWarning
          headerText='Подтвердите удаление'
          messageText={`Удалить колонку “${removableTaskList.name}”?`}
          approveButtonText='Удалить'
          cancelButtonText='Отмена'
          colorBtn='red'
          onApproveClick={() => {
            deleteTaskList()
            setIsModalDeleteCol(false)
          }}
          onCancelClick={() => setIsModalDeleteCol(false)}
        />
      }

      {isModalStatus && (
        <ModalTaskStatus
          columns={columns}
          currentColumn={currentColumn}
          setIsModal={(e) => setIsModalStatus(e)}
        />
      )}

      {isModal && <ModalAddTask
        isNew={isNew}
        event_id={eventId}
        setIsNew={setIsNew}
        setIsModal={(e) => setIsModal(e)}
        setIsModalExit={setIsModalExit}
        infoTask={infoTask}
        isLoadInfoTask={isLoadInfoTask}
        attendees={projectAttendees}
        taskId={taskId}
        setInfoTask={e => setInfoTask(e)}
        setTasks={e => setTasks(e)}
        selectedColumn={selectedColumn}
        allColumns={projectPreview}
        query={query}
        fetchDeleteTask={e => {
          fetchDeleteTask(e)
        }}
        searchParams={searchParams}
        setUpdateId={setUpdateId}
        setActualId={setActualId}
        crm
      />}

      {isModalExportReport && <ModalSummaryCrm
        funnel_id={currentBord?.id}
        taskId={taskId}
        selectedExecutor={selectedExecutor}
        selectedAuthor={selectedAuthor}
        selectedCoExecutor={selectedCoExecutor}
        setIsModal={setIsModalExportReport}
      />}

      <div className='task-list'
        style={{ maxHeight: selectView === 'Table' ? '100%' : '' }}
      >

        {taskId != -1 && <Tabs
          tabs={btn_tab}
          pageValue={pageValue}
          //   spanTab
          setPageValue={(e) => {
            setPageValue(e);
            setCurrentBord(null)
          }}
        // query={location.search}
        />}

        <Routes>
          <Route path="*"
            element={
              <>
                <div className="task-list__top-info">
                  <div className="task-list__breadcrumbs">
                    <p
                      onClick={(e) => {
                        sessionStorage.removeItem('crmProjectId');
                        setTaskId(null);
                        sessionStorage.removeItem('crmProjectName');
                        setSelectedProjectAbove(null);
                        navigate('../project-for-crm/project');
                      }}
                      className="task-list__breadcrumbs-item"
                    >
                      Проекты
                    </p>
                    <p
                      className="task-list__breadcrumbs-item"
                      style={{ position: 'relative', zIndex: 7 }}
                    >
                      <DropDownSelector
                        placeholder='Выберите проект'
                        state={selectedProject}
                        options_prop={projectPreview}
                        setState={(project) => {
                          if (project?.label) {
                            const { label, value } = project;
                            sessionStorage.setItem('crmProjectName', label);
                            setCurrPrjoect(value);
                            setSelectedStatus([]);
                            setSearchValue('')
                          }
                        }}
                        onBlur={(e) => refContainer?.current?.focus()}
                      />
                    </p>

                    <ButtonBasic
                      whiteGreen
                      text='Обновить'
                      width='auto'
                      onClick={() => setIsUpdateColumn(!isUpdateDataColumn)}
                    />
                  </div>

                  <div className="task-list__sum-tasks">
                    {+taskId === -1 && (
                      <p className="task-list__sum-text">
                        Всего проектов: <span className='task-list__sum-text_span'>
                          {loadTotalCount ? <MoonLoader size={10} /> : (columns?.length || 0)}
                        </span>
                      </p>
                    )}
                    <p className="task-list__sum-text">
                      Всего сделок: {<span className='task-list__sum-text_span'>
                        {loadTotalCount ? <MoonLoader size={10} /> : (totalProject || 0)}
                      </span>}
                    </p>
                  </div>
                </div>

                <div className="toolbar-top">
                  <div className="left-box">
                    <div className="members-box">
                      <Tooltip
                        child={
                          <ButtonWithIcon
                            grey
                            round
                            icon={add_user}
                            style={{
                              marginRight: '8px'
                            }}
                            onClick={(e) => {
                              setShowModalAddMember(true)
                            }}
                          />
                        }
                        text="Добавить участника"
                        maxWidth='150px'
                      />

                      {(
                        <>
                          {isShowAllExecutor
                            ? arr_projectAttendees
                            : arr_projectAttendees?.splice(0, 6)}

                          {selectedExecutor?.length > 0 && (
                            <button
                              className="btn-close"
                              onClick={(e) => {
                                setSelectedExecutor([]);
                                setUpdateCol(true);
                              }}
                            >
                              <img src={close_icon} />
                            </button>
                          )}

                          <ButtonWithIcon
                            whiteGreen
                            round
                            icon={<span style={{ fontSize: '10px', fontWeight: 600 }}>+ {projectAttendees?.length > 7 ? projectAttendees?.length - 6 : ''}</span>}
                            style={{
                              marginLeft: '8px'
                            }}
                            onClick={(e) => setIsModalListExecutor(true)}
                          />
                        </>
                      )}
                    </div>
                    {
                      <>
                        {+taskId === -1 && (
                          <DropDownSelector
                            placeholder="Статус"
                            isClearable={true}
                            options_prop={statusOptions}
                            total={selectedStatus?.length}
                            state={selectedStatus}
                            setState={setSelectedStatus}
                            multi
                            onBlur={(e) => {
                              fetchAllColumns(false, +taskId);
                              fetchTableData([])
                              fetchProjects(+taskId);
                              fetchProjectPreview();
                              refContainer?.current?.focus();
                              setIsUpdateColumn(!isUpdateDataColumn)
                            }}
                          />
                        )}

                        {selectView == 'Tile-long' && <ButtonsSort
                          btnSort={btn_sort}
                          currentSort={currentSort}
                          setCurrentSort={setCurrentSort}
                          sort={sort1}
                          setSort={setSort1}
                        />}
                      </>
                    }
                    {/* <Checkbox value={isRead} onChange={(checked) => {
              setIsRead(checked)
              refContainer?.current?.focus();
            }}>
              Показать непрочитанные
            </Checkbox>

            <Checkbox
              value={isShowAuthor}
              onChange={(checked) => {
                setIsShowAuthor(!isShowAuthor)
                refContainer?.current?.focus();
              }}
            >
              Показать создателя
            </Checkbox>

            <Checkbox
              value={isDelete}
              onChange={(checked) => {
                setIsDelete(checked)
                refContainer?.current?.focus();
              }}
            >
              В корзине
            </Checkbox> 

            <ButtonBasic
              green
              text={!isVisibleCheckbox ? 'Выбрать для печати' : `Печать ${listPrint?.length}`}
              width='auto'
              onClick={() => {
                if (!isVisibleCheckbox) {
                  setIsVisibleCheckbox(true)
                } else {
                  alert(`Распечатать задачи ${listPrint}`)
                }
              }}
            />*/}
                  </div>

                  <div className="right-filter-box">
                    <InputDynamicWidth
                      placeholder="Поиск сделки"
                      position="left"
                      maxWidth="100%"
                      drop={false}
                      value={searchValue}
                      onChange={deboudnceSearchTask}
                    />

                    <ViewSwitch
                      tile={false}
                      selectView={selectView}
                      setSelectView={(e) => {
                        setSelectView(e)
                        refContainer?.current?.focus();
                      }}
                    />
                  </div>
                </div>

                <div
                  ref={refContainer}
                  className="main-task-box"
                  tabIndex={5}
                  style={{
                    outline: 'none',
                    overflowX: selectView === 'Table' ? 'visible' : (isBlockKey ? 'hidden' : 'auto'),
                    overflowY: selectView === 'Table' ? 'visible' : 'hidden',
                    maxWidth: ((selectView === 'Table') && (taskId != -1)) ? 'calc(100% - 218px)' : '100%',
                    gap: selectView == 'Table' ? '8px' : '',
                  }}
                >

                  {+taskId != -1 && <BordTask
                    taskId={taskId}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    setCurrentBordTask={setCurrentBord}
                    ref={refBoard}
                    dependenciesUpdate={[updateId, actualId]}
                    setBordListLength={setBordListLength}
                    crm
                  />}

                  <div
                    ref={refTable}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      overflowX: selectView == 'Table' ? 'visible' : '',
                      overflowY: selectView == 'Table' ? 'visible' : '',
                      gap: selectView == 'Table' ? '8px' : '',
                    }}
                  >



                    <div className='task-list__btn-group'>
                      {(taskId != -1 && author?.login == email && selectView !== 'Table') && <ButtonBasic
                        whiteBlue
                        width='240px'
                        onClick={() => setShowModalNewTaskList(true)}
                        text={'Добавить колонку'}
                        size="40px"
                        disabled={!currentBord}
                        style={{
                          minHeight: '40px',
                          margin: '0px 8px 8px 8px'
                        }}
                      />}

                      <ButtonBasic
                        blue
                        width='240px'
                        onClick={() => setIsModalExportReport(true)}
                        text={'Выгрузить отчет'}
                        size="40px"
                        style={{
                          minHeight: '40px',
                          margin: '0px 8px 8px 8px'
                        }}
                      />
                    </div>

                    {(taskId != -1 && author?.login == email && selectView !== 'Table') &&
                      <>

                        {bordListLength > 0 ? null : <StepItem
                          title='Для начала работы создайте воронку в панели слева'
                        />}

                        {(bordListLength > 0 && !currentBord && !columns?.length) && <StepItem
                          title='Для начала работы выберите воронку в панели слева'
                        />}
                      </>
                    }

                    {selectView == 'Tile-long' && (
                      <div
                        className={`task-list__content ${columnsAreUpdating ? 'loading' : ''
                          }`}
                        dragover={columnDragStarted.toString()}
                        onDrag={(e) => customDragScrollHandler(e)}
                        ref={refTaskBox}
                      >


                        {load ? (
                          <Loader style={{ marginTop: '200px' }} />
                        ) : (
                          <>
                            {columns?.length > 0 &&
                              !load &&
                              columns
                                .map((col, ind) => (
                                  <Fragment key={col.typeId}>
                                    {
                                      <div
                                        key={col?.id}
                                        className="task-list__hover-box"
                                        onDragOver={(e) => {
                                          // if (author?.login == email) {
                                          e.preventDefault();
                                          setIsOver(ind); // Устанавливаем состояние при перетаскивании
                                          // }
                                        }}
                                        onDrop={(e) => {
                                          if (draggableColumn) {
                                            // if (author?.login == email) {
                                            dropColumnHandler(e, col);
                                            setIsOver(false);
                                          }
                                          // }
                                        }}
                                        onDragEnter={(e) => {
                                          // if (author?.login == email) {
                                          e.target.classList.add('hover');
                                          setIsOver(false);
                                          // }
                                        }}
                                        onDragLeave={(e) => {
                                          // if (author?.login == email) {
                                          e.target.classList.remove('hover');
                                          setIsOver(false); // Сбрасываем состояние при выходе
                                          // }
                                        }}
                                        style={{
                                          border:
                                            isOver === ind
                                              ? '1px solid #51CA64'
                                              : 'transparent',
                                        }}
                                      >
                                        <ColumnTask
                                          isShowAuthor={isShowAuthor}
                                          dragStartColumn={dragStartColumn}
                                          dragOverHandler={dragOverHandler}
                                          dropCardHandler={dropCardHandler}
                                          setIsOver={setIsOver}
                                          positionElement={positionElement}
                                          projectName={projectName}
                                          col={col}
                                          setIsEditCol={setIsEditCol}
                                          isEditCol={isEditCol}
                                          setIsBlockKey={setIsBlockKey}
                                          changeTaskListName={updateTaskListPlace}
                                          setCurrentColumn={setCurrentColumn}
                                          setIsModalStatus={setIsModalStatus}
                                          taskId={taskId}
                                          setRemovableTaskList={setRemovableTaskList}
                                          setIsModalDeleteCol={setIsModalDeleteCol}
                                          openModal={openModal}
                                          setSelectedColumn={setSelectedColumn}
                                          setIsModal={setIsModal}
                                          columnNameIsUpdating={columnNameIsUpdating}
                                          fetchProjectToRedirect={fetchProjectToRedirect}
                                          author={author}
                                          email={email}
                                          actual={actual}
                                          refHeader={refHeader}
                                          isOpenActiveMenu={isOpenActiveMenu}
                                          // tasksByStatus={tasksByStatus}
                                          dragStartHandler={dragStartHandler}
                                          task_permissible={task_permissible}
                                          openTask={openTask}
                                          fetchDeleteTask={fetchDeleteTask}
                                          setIsOpenActiveMenu={setIsOpenActiveMenu}
                                          selectedExecutor={selectedExecutor}
                                          selectedAuthor={selectedAuthor}
                                          selectedCoExecutor={selectedCoExecutor}
                                          selectedStatus={selectedStatus}
                                          setLoad={setLoad}
                                          headers={headers}
                                          body={{
                                            unviewed: isRead,
                                            order_field: currentSort?.value ? currentSort?.value : 'deal_created_at',
                                            order_direction: sort1 == 'ASC' ? 'desc' : 'asc',
                                            search: searchValue,
                                            on_trash: isDelete,
                                            page: 1,
                                            limit: 100,
                                            responsible_list: selectedExecutor?.length > 0 ? selectedExecutor : []
                                          }}
                                          actualId={actualId}
                                          setActualId={setActualId}
                                          updateId={updateId}
                                          setUpdateId={setUpdateId}
                                          setIsUpdateTotal={setIsUpdateTotal}
                                          isUpdateTotal={isUpdateTotal}
                                          refsTotal={refsTotal}
                                          fetchAllColumns={() => { fetchAllColumns(false, +taskId) }}
                                          refContainer={refContainer}
                                          setGeneralTotal={setGeneralTotal}
                                          setCountCol={setCountCol}
                                          columns={columns}
                                          searchValue={searchValue}
                                          isVisibleCheckbox={isVisibleCheckbox}
                                          listPrint={listPrint}
                                          setListPrint={(e) => setListPrint(e)}

                                          currentBord={currentBord}
                                          search={searchValue}
                                          isModal={isModal}
                                          // Обновление колонок 
                                          isUpdateDataColumnList={isUpdateDataColumn}
                                          setIsUpdateColumn={setIsUpdateColumn}
                                          crm
                                        />
                                      </div>
                                    }
                                  </Fragment>
                                ))}
                          </>
                        )}
                      </div>
                    )}

                    {/* Табличный вид */}
                    {selectView == 'Table' && (
                      <TableBox
                        // refContainer={refTable}
                        {...tableProps}
                        ref={paginatorRef}
                        paginator={true}
                        fetchCallback={fetchTableData}
                        onAction={onActionTable}
                        contextMenuArr={contextMenuArr}
                        child={(+taskId != -1) ?
                          <Checkbox
                            value={isShowAdditionalFields}
                            onChange={(e) => setIsShowAdditionalFields(!isShowAdditionalFields)}
                          >
                            Учитывать дополнительные поля
                          </Checkbox> : null}
                      />
                    )}
                  </div>
                </div>

                {isVisible && selectView !== 'Table' && (
                  <div
                    className="scrollbar"
                    ref={refScrollbar}
                    onScroll={(e) => {
                      if (refContainer.current) {
                        refContainer.current.scrollLeft = e.target.scrollLeft;
                      }
                      scrollBottom();
                    }}
                    style={{
                      height: '16px',
                      position: 'fixed',
                      bottom: 0,
                      left: leftPosition + 'px',
                      maxWidth: widthTaskList + 'px',
                      minWidth: widthTaskList + 'px',
                      width: '100%',
                      overflowX: isBlockKey ? 'hidden' : 'auto',
                      overflowY: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        minWidth: widtContainer,
                        maxWidth: widtContainer,
                      }}
                    ></div>
                  </div>
                )}
              </>}
          />

          {tokenWiki && <Route
            path={`${taskId || eventId}/wiki/*`}
            element={
              <Main
                isShowMain={false}
                readonly={false}
                activeLang={'ru'}
                pathBread={`crm/crm-list/${taskId || eventId}`}
                pathsWebName={pathsWebName}
                setPathsWebName={(e) => setPathsWebName(e)}
                paths={paths}
                setPaths={setPaths}
                token={tokenWiki}
                setToken={setTokenWiki}
                wikiId={wikiId}
              />
            } />}

          {<Route
            path={`${taskId || eventId}/wiki/*`}
            element={
              <NotActive />} />}

          <Route
            path={`${taskId || eventId}/files/*`}
            element={fileId ?
              <MainDirectory
                isShowMain={false}
                mainPath={`/crm/crm-list/${taskId || eventId}/files`}
                activeLang={'ru'}
                pathBread={`crm/crm-list/${taskId || eventId}/files`}
                directory={true}
                fileId={fileId}
                projectId={taskId}
                query={'crm'}
              />
              :
              <NotActive />
            } />

          <Route
            path={`${taskId || eventId}/task_list/*`}
            element={<TaskListTable
              project_id={taskId || eventId}
            />} />
        </Routes>
      </div>
    </>
  );
};

// Обёртка: при смене проекта (первый сегмент пути) компонент монтируется заново,
// весь state сбрасывается, как после перезагрузки, но без неё
const CRMList = (props) => {
  const projectKey = useParams()['*']?.split('/')[0];
  return <CRMListInner key={projectKey} {...props} />;
};


export { CRMList };
